<div *ngIf="mainPageLoader" class="loading-shade">
    <div class="loader" alt="Please wait..."></div>
</div>
<div *ngIf="!mainPageLoader" style="position: relative;">
    <div class="container-fluid d-flex align-items-center justify-content-center" style="position: fixed; top: 0; bottom: 0; left: 0; right: 0; background-color: #707070;">
        <div class="row m-0 d-flex justify-content-center">
            <div *ngIf="!hideForm && !apiFailMsg" class="col-12 col-md-7 col-lg-5 col-xl-4 feedback_wrapper">
                <form [formGroup]="feedbackForm" (ngSubmit)="onSubmit()">
                    <div class="row m-0">
                        <div class="col-12 mb-4 title">
                            {{ 'sendUsFeedback' | translate }}
                        </div>
                        <div class="col-12 mb-4">
                            <p class="mb-2 font_size" style="font-weight: bold;">
                                <span style="color: #da291c;">*</span>&nbsp;
                                {{ 'howWouldYouRateTopic' | translate }}?
                            </p>
                            <mat-icon *ngFor="let star of starArr; index as i" class="mat_icons" [ngClass]="{ 'ratings_selected': ratings >= (i+1) }"
                                (click)="onClick(star)" aria-hidden="false" [matTooltip]="star" matTooltipPosition="above">
                                grade
                            </mat-icon>
                            <p class="font_size d-flex align-items-center">
                                {{ 'youRated' | translate }}: {{ ratings }}/5&nbsp;
                                <mat-icon class="rating_icon" style="color: #da291c;" *ngIf="ratings === 1" aria-hidden="false">sentiment_very_dissatisfied</mat-icon>
                                <mat-icon class="rating_icon" style="color: #da7c1c;" *ngIf="ratings === 2" aria-hidden="false">sentiment_dissatisfied</mat-icon>
                                <mat-icon class="rating_icon" style="color: #1fda1c;" *ngIf="ratings === 3" aria-hidden="false">sentiment_satisfied</mat-icon>
                                <mat-icon class="rating_icon" style="color: #1fda1c;" *ngIf="ratings === 4" aria-hidden="false">sentiment_satisfied_alt</mat-icon>
                                <mat-icon class="rating_icon" style="color: dodgerblue;" *ngIf="ratings === 5" aria-hidden="false">sentiment_very_satisfied</mat-icon>
                            </p>
                        </div>
                        <div class="col-12 mb-4">
                            <p class="mb-2 font_size" style="font-weight: bold;">
                                <span style="color: #da291c;">*</span>&nbsp;
                                <label for="review">{{ 'writeReview' | translate }}</label>
                            </p>
                            <textarea id="review" formControlName="userReview" class="form-control input_font text_field" placeholder="{{ 'whatYouLikeDislike' | translate }}" required></textarea>
                        </div>
                        <div class="col-12 mb-4">
                            <p class="mb-2 font_size" style="font-weight: bold;">
                                <span style="color: #da291c;">*</span>&nbsp;
                                <label for="email">{{ 'yourEmail' | translate }}</label>
                            </p>
                            <input id="email" type="email" formControlName="userEmail" class="form-control input_font text_field" [ngClass]="{'disableField': disableField}" placeholder="{{ 'pleaseProvideEmail' | translate }}" required />
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn submit_btn" [disabled]="!feedbackForm.valid || (ratings === 0)">{{ 'sendFeedback' | translate }}</button>
                        </div>
                    </div>
                </form>
            </div>
            <div *ngIf="hideForm" class="col-12 bg-white text-center" style="padding: 20px; border-radius: 10px;">
                <p><mat-icon style="color: dodgerblue;" aria-hidden="false">thumb_up</mat-icon></p>
                <p>{{ 'thankYouForFeedback' | translate }}.</p>
                <p>{{ 'closeThisPage' | translate }}.</p>
            </div>
            <div *ngIf="apiFailMsg" class="col-12 bg-white text-center" style="padding: 20px; border-radius: 10px;">
                <p><mat-icon style="color: #da291c;" aria-hidden="false">cancel</mat-icon></p>
                <p>{{ 'somethingWentWrong' | translate }}!</p>
                <p>{{ 'pleaseContactAdminCust' | translate }}.</p>
            </div>
        </div>
    </div>
</div>